/**
 * O PERFIL DE IMPORTAÇÃO — o leitor de OS de UM ERP.
 *
 * O núcleo do PCP não lê PDF nenhum: ele pede a UM perfil que leia. Isto é o
 * que faz o sistema servir mais de uma empresa — cada ERP tem o seu layout, e
 * cada layout tem o seu perfil. O perfil da Gráfica Boa União (o PDF do ERP
 * atual, lido por coordenadas) é o padrão.
 *
 * Um perfil novo se registra na lista abaixo. Nada mais muda: o agente e a tela
 * de importação pedem o perfil e usam o que ele devolver.
 */

import { lerOs, VERSAO_LEITOR, type ResultadoDaLeitura } from './ler.js';

export interface PerfilDeImportacao {
  /** Estável; vai gravado em cada importação, para rastrear o leitor. */
  id: string;
  /** Como aparece na tela. */
  nome: string;
  versao: string;
  ler(dados: Uint8Array): Promise<ResultadoDaLeitura>;
}

/** O perfil da Gráfica Boa União: o PDF do ERP atual, por coordenadas. */
export const PERFIL_ZSLPDF: PerfilDeImportacao = {
  id: 'gbu-zslpdf',
  nome: 'ERP da gráfica (ZSLPDF)',
  versao: VERSAO_LEITOR,
  ler: lerOs,
};

/** Os perfis registrados. Acrescentar aqui é o que traz uma empresa nova. */
const PERFIS: readonly PerfilDeImportacao[] = [PERFIL_ZSLPDF];

/** O perfil por id, ou o padrão (`PERFIL_ZSLPDF`). */
export function perfilDeImportacao(id?: string | null): PerfilDeImportacao {
  if (!id) return PERFIL_ZSLPDF;
  return PERFIS.find((p) => p.id === id) ?? PERFIL_ZSLPDF;
}

export function perfisRegistrados(): readonly PerfilDeImportacao[] {
  return PERFIS;
}
